module.exports = __webpack_public_path__ + "static/media/record-badge.a5541e36.svg";